// Medición de la landing (blocks/skindion-landing-attribution.liquid): al agregar al carrito desde la plantilla guarda
// los atributos ocultos _lnd y _oferta, que el pedido hereda. Escucha el cartLinesUpdate que ya despachan Horizon
// (product-form.js) y el carrito de la promo (skindion-cart.js, mutateCart): no es un evento ni un pixel nuevo. Escribe
// con /cart/update.js solo si el agregar no falló. Última landing con «agregar» gana.
// Script clásico: la lógica pura vive en window.SkindionLandingAttribution para probarla en Node
// (tools/promo-cart.test.mjs). Mismo comportamiento que <promo-2x1-attribution> del 2x1 (misión 07f).
(() => {
  const logic = (window.SkindionLandingAttribution = window.SkindionLandingAttribution || {
    /** Atributos ocultos de la landing; null sin Landing ID. */
    attributes({ lnd = '', oferta = '' } = {}) {
      const id = String(lnd).trim();
      if (!id) return null;
      const attributes = { _lnd: id };
      if (String(oferta).trim()) attributes._oferta = String(oferta).trim();
      return attributes;
    },
    /** Solo los «agregar» cuentan: quitar o cambiar cantidades en el carrito no reescribe la landing. */
    isAdd(event) {
      return event?.action === 'add';
    },
  });

  if (customElements.get('skindion-landing-attribution')) return;

  customElements.define(
    'skindion-landing-attribution',
    class SkindionLandingAttribution extends HTMLElement {
      #abort = new AbortController();

      connectedCallback() {
        const attributes = logic.attributes(this.dataset);
        if (!attributes) return;
        const { signal } = this.#abort;
        import('@shopify/events')
          .then(({ StandardEvents }) => {
            if (signal.aborted) return;
            document.addEventListener(
              StandardEvents.cartLinesUpdate,
              (event) => {
                if (!logic.isAdd(event)) return;
                // Con promesa, se espera a que Shopify responda; si el agregar falló, no se escribe nada.
                Promise.resolve(event.promise)
                  .then((result) => {
                    if (!result?.detail?.didError) this.#save(attributes);
                  })
                  .catch(() => {});
              },
              { signal }
            );
          })
          .catch(() => {});
      }

      disconnectedCallback() {
        this.#abort.abort();
      }

      async #save(attributes) {
        try {
          await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes }),
          });
        } catch {
          // Sin red: la medición no frena la compra.
        }
      }
    }
  );
})();
